import { createAction } from '@reduxjs/toolkit';

// Player action creators
export const setPlaying = createAction<boolean>('player/setPlaying');
export const setCurrentDuration = createAction<number>(
  'player/setCurrentDuration'
);
export const seekToTime = createAction<number | null>('player/seekToTime');
export const setActiveIssueId = createAction<number | null>(
  'player/setActiveIssueId'
);
export const resetPlayer = createAction('player/reset');
